<template>
<div>
  <el-tabs v-if="!!mainObj.project_id" type="border-card" v-model="card_index">
    <el-tab-pane label="费用异动" name="MeterOrderUnusualChangeFlow">
      <MeterOrderUnusualChangeFlow v-if="card_index==='MeterOrderUnusualChangeFlow'&&mainObj.read_month" />
<!--      <MeterOrderUnusualChange v-if="card_index==='MeterOrderUnusualChangeFlow'&&mainObj.read_month" />-->
    </el-tab-pane>
    <el-tab-pane label="用户费用" name="MeterOrderUserFlowList">
      <MeterOrderUserFlowList v-if="card_index==='MeterOrderUserFlowList'&&mainObj.read_month" />
    </el-tab-pane>
    <el-tab-pane label="用量计费" name="MeterOrderFlowList">
      <MeterOrderFlowList v-if="card_index==='MeterOrderFlowList'&&mainObj.read_month" />
    </el-tab-pane>
    <el-tab-pane label="分摊计费" name="MeterOrderObjectFlowList">
      <MeterOrderObjectFlowList v-if="card_index==='MeterOrderObjectFlowList'&&mainObj.read_month" />
    </el-tab-pane>
    <el-tab-pane label="能耗分摊图" name="MeterOrderFlowDiagram">
      <MeterOrderFlowDiagram v-if="card_index==='MeterOrderFlowDiagram'&&mainObj.read_month" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import MeterOrderFlowList from "./components/MeterOrderFlowList";
import MeterOrderObjectFlowList from "./components/MeterOrderObjectFlowList";
import MeterOrderFlowDiagram from "./components/MeterOrderFlowDiagram";
import MeterOrderUserFlowList from "./components/MeterOrderUserFlowList";
import MeterHttp from "../../common/MeterHttp";
import MeterOrderUnusualChangeFlow from "./components/MeterOrderUnusualChangeFlow";
import MeterOrderUnusualChange from "../meter_order/MeterOrderUnusualChange";
export default {
  name: "MeterOrderFlow",
  components: {
    MeterOrderUnusualChange,
    MeterOrderUnusualChangeFlow,
    MeterOrderUserFlowList, MeterOrderFlowDiagram, MeterOrderObjectFlowList, MeterOrderFlowList},
  data(){
    return{
      batch_number:null,
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
        id:"",
        map_id:"",
        type:"",
        read_month:"",
      },
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        house_id:"",
        house_name:"",
        customer_id:"",
        customer_name:"",
        should_charge_date:"",
        energy:"",
        is_lock:"",
        is_examine:"",
        charging_standard:'',
        chargeItem_name_id:''
      },
      card_index:"MeterOrderUserFlowList",
      order_query:{user_type:2},
    }
  },
  provide(){
    return{
      mainObj:this.mainObj,
      where:this.where,
      order_query:this.order_query,
    }
  },
  mounted() {
    const that=this;
    that.batch_number=that.$route.query.batch_number;
    that.getMeterOrderFlow();
  },
  methods:{
    getMeterOrderFlow(){
      const that=this;
      let from_data={};
      MeterHttp.post("MeterOrderFlow/getBatchNumber",{batch_number:that.batch_number,},ret=>{
        if(ret.code){
          that.mainObj.project_id=ret.data.project_id;
          that.mainObj.read_month=ret.data.read_month;
          that.mainObj.house_name=ret.data.house_name;
          let where=JSON.parse(ret.data.where_str);
          that.where.number=where.number;
          that.where.name=where.name;
          that.where.apportion_meter_types=where.apportion_meter_types.split(",");
          that.where.meter_type=where.meter_type;
          that.where.house_id=where.house_id;
          that.where.house_name=where.house_name;
          that.where.customer_id=where.customer_id;
          that.where.customer_name=where.customer_name;
          that.where.should_charge_date=where.should_charge_date;
          that.where.energy=where.energy;
          that.where.is_lock=where.is_lock;
          that.where.is_examine=where.is_examine;
          that.order_query.user_type=where.user_type;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order_flow/MeterOrderFlow.vue